import * as amplitude from '@amplitude/analytics-browser'

import {
  INFRASTRUCTURE_ENVIRONMENT_TYPE,
  AMPLITUDE_API_KEY,
  AMPLITUDE_PROD_API_KEY,
} from '@/constants'

export const amplitudeInit = (username: string) => {
  // Production
  if (INFRASTRUCTURE_ENVIRONMENT_TYPE === 'prod') {
    amplitude.init(AMPLITUDE_PROD_API_KEY, username, {
      instanceName: 'prod',
      defaultTracking: true,
    })
  }

  // Staging
  if (INFRASTRUCTURE_ENVIRONMENT_TYPE === 'stage') {
    amplitude.init(AMPLITUDE_API_KEY, username, {
      instanceName: 'stage',
      defaultTracking: true,
    })
  }
}

export { amplitude }
